module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE0IDIyIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggc3Ryb2tlPSIjRkVGRUZFIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEuNSAzLjg3VjEuNTE3aDExLjM3M1YzLjg3TDguMjggMTAuOTVsNC41OTMgNi45OTR2Mi40NEgxLjV2LTIuNDRsNC41NS02Ljk5M3oiLz4KICAgIDxwYXRoIGZpbGw9IiNGRUZFRkUiIGQ9Ik01LjUzOCA3LjAzbDMuMjYtLjAwMkw3LjE2IDkuNTU1IDUuNTM4IDcuMDN6bS0yLjM2IDExLjYydi0uMTc2bDIuMzY0LTMuNjM1IDMuMjQzLS4wMzQgMi40MSAzLjY3di4xNzJIMy4xNzh6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/icons/hour-glass-low.svg
// module id = 1787
// module chunks = 2